import i18next from 'i18next';
import { showSnackbar, SnackbarType } from '../app';
import { shortenString, stripHtml } from '../helpers/stringHelpers';
import { createAppAsyncThunk } from '../store/extensions';
import { Story } from '../stories/stories/model/Story';
import { getSharableDynamicLink } from './service';
const MAX_SOCIAL_DESCRIPTION_LENGTH = 150;

export const createStoryShareLink = createAppAsyncThunk(
  'share/story',
  async (
    args: { story: Story; baseUrl: string; imageUrl?: string },
    { dispatch }
  ) => {
    try {
      const url = `${args.baseUrl}/stories/story/${args.story.id}`;
      const socialTitle = args.story.title;
      const socialDescription = shortenString(
        stripHtml(args.story.content),
        MAX_SOCIAL_DESCRIPTION_LENGTH
      );

      const socialImageLink =
        args.imageUrl || `${args.baseUrl}/assets/carecircle_og.png`;

      const shareLink = await getSharableDynamicLink({
        url,
        socialTitle,
        socialDescription,
        socialImageLink,
      });

      return shareLink;
    } catch (error) {
      console.log('Error on generating profile share link', error);
      dispatch(
        showSnackbar(
          SnackbarType.error,
          i18next.t('share_cannot_generate_short_link')
        )
      );
    }

    return undefined;
  }
);
